const whereShouldBeActive = (local, demo, production) => {
  const env = process.env.REACT_APP_ENV;
  const isLocal = process.env.NODE_ENV === 'development';

  if (isLocal) {
    return local;
  } else if (env === 'demo') {
    return demo;
  } else {
    return production;
  }
};

export const modules = {
  group_reco: whereShouldBeActive(true, true, true),
  filterByRecart: whereShouldBeActive(true, true, true),
  survey: whereShouldBeActive(true, true, true),
  greeting_mood_tracker: whereShouldBeActive(true, true, true),
  about_me_score: whereShouldBeActive(true, true, true),
  moodTrackerComment: whereShouldBeActive(true, true, true),
  replyComment: whereShouldBeActive(true, true, false),
  chat: whereShouldBeActive(true, true, true)
};
